import { cn } from "@/lib/utils";
import type { CoachLensStatus } from "@/lib/behavior/coachLensStatus";

export interface CoachLensStatusBadgeProps {
  status: CoachLensStatus;
  onClick?: () => void;
  disabled?: boolean;
}

const STATUS_STYLES: Record<CoachLensStatus, { dot: string; label: string; text: string }> = {
  active:     { dot: "bg-emerald-500", label: "text-emerald-400",      text: "Lens active" },
  incomplete: { dot: "bg-amber-400",   label: "text-amber-400",        text: "Lens incomplete" },
  stale:      { dot: "bg-amber-400",   label: "text-amber-400",        text: "Lens may be stale" },
  missing:    { dot: "bg-muted-foreground/40", label: "text-muted-foreground", text: "No lens set" },
  unavailable: { dot: "bg-rose-400", label: "text-rose-400", text: "Lens unavailable" },
};

export function CoachLensStatusBadge({
  status,
  onClick,
  disabled = false,
}: CoachLensStatusBadgeProps) {
  const style = STATUS_STYLES[status];

  const inner = (
    <span className={cn("flex items-center gap-1.5 text-xs", style.label)}>
      <span
        className={cn("inline-block h-2 w-2 shrink-0 rounded-full", style.dot)}
        aria-hidden="true"
      />
      {style.text}
    </span>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className="rounded focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
      >
        {inner}
      </button>
    );
  }

  return <div>{inner}</div>;
}
